import { Children } from 'react';
import { Container } from './styled.js';
import { BreadcrumbMenu } from './BreadcrumbMenu/index.js';
import { jsx } from 'react/jsx-runtime';

function Breadcrumbs(props) {
  var children = props.children,
    _props$truncate = props.truncate,
    truncate = _props$truncate === void 0 ? false : _props$truncate;
  var childrenAmount = Children.count(children);
  var useTruncate = childrenAmount > 5;
  if (truncate && useTruncate) {
    return /*#__PURE__*/jsx(BreadcrumbMenu, {
      children: children
    });
  }
  return /*#__PURE__*/jsx(Container, {
    children: children
  });
}

export { Breadcrumbs };
